import { FC } from "react";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown } from "../../../design-system";
import { DocumentCard } from "../../../design-system/components/DocumentList/DocumentCard";
import { Project, ProjectAnalysis } from "../../../types/ProjectTypes";
import { getAttachmentDownloadUrl } from "../../../common/api/ProjectClient";
import styles from "./AttachmentsDropdown.module.less";

interface AttachmentsDropdownProps {
    project: Project;
    analysis: ProjectAnalysis;
}

export const AttachmentsDropdown: FC<AttachmentsDropdownProps> = ({ project, analysis }) => {
    const attachments = analysis.attachments ?? [];
    if (attachments.length === 0) {
        return null;
    }

    const uploadedAt =
        analysis.completedDate ?? analysis.submittedDate ?? analysis.recordCreationDate;

    const renderPanel = () => (
        <div className={styles.dropdownPanel}>
            <div className={styles.dropdownTitle}>Attachments</div>
            <div className={styles.divider} />
            <div className={styles.attachmentList}>
                {attachments.map((doc) => (
                    <a
                        key={doc.id}
                        href={getAttachmentDownloadUrl(project.id, analysis.version, doc.id)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.attachmentItem}
                    >
                        <DocumentCard
                            name={doc.name}
                            uploadedBy="InfinityLoop"
                            uploadedAt={uploadedAt}
                        />
                    </a>
                ))}
            </div>
        </div>
    );

    return (
        <Dropdown
            menu={{ items: [] }}
            dropdownRender={renderPanel}
            trigger={["click"]}
            placement="bottomRight"
        >
            <button type="button" className={styles.attachmentsTrigger}>
                Attachments
                <DownOutlined className={styles.chevron} />
            </button>
        </Dropdown>
    );
};
